import { Phone, Mail, Instagram, MessageCircle } from "lucide-react";
import { PHONE_DISPLAY, PHONE_TEL, EMAIL, INSTAGRAM_HANDLE, INSTAGRAM_URL, waLink } from "@/lib/site";

export default function Footer() {
  return (
    <footer className="bg-black border-t border-white/10">
      <div className="max-w-7xl mx-auto px-4 py-14 grid md:grid-cols-3 gap-10">
        <div>
          <img
            src="/images/logo.png"
            alt="Logo Brasil Transportes"
            loading="lazy"
            className="h-20 w-auto object-contain"
          />
          <p className="mt-4 text-sm text-neutral-500 leading-relaxed">
            Reboque, guincho e assistência veicular em Belém, Região Metropolitana e outras
            localidades do Pará mediante consulta.
          </p>
        </div>

        <div>
          <h3 className="font-bebas text-xl uppercase tracking-wide text-[#FEFB0E]">Contato</h3>
          <ul className="mt-4 space-y-3 text-sm">
            <li>
              <a href={PHONE_TEL} data-testid="footer-phone-link" className="flex items-center gap-2 text-neutral-300 hover:text-[#FEFB0E] transition-colors">
                <Phone className="w-4 h-4" /> {PHONE_DISPLAY}
              </a>
            </li>
            <li>
              <a href={`mailto:${EMAIL}`} data-testid="footer-email-link" className="flex items-center gap-2 text-neutral-300 hover:text-[#FEFB0E] transition-colors break-all">
                <Mail className="w-4 h-4 shrink-0" /> {EMAIL}
              </a>
            </li>
            <li>
              <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" data-testid="footer-instagram-link" className="flex items-center gap-2 text-neutral-300 hover:text-[#FEFB0E] transition-colors">
                <Instagram className="w-4 h-4" /> {INSTAGRAM_HANDLE}
              </a>
            </li>
          </ul>
        </div>

        <div>
          <h3 className="font-bebas text-xl uppercase tracking-wide text-[#FEFB0E]">Chamar guincho</h3>
          <p className="mt-4 text-sm text-neutral-500">Fale com a Brasil Transportes agora mesmo.</p>
          <a
            href={waLink()}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-whatsapp-btn"
            className="mt-4 inline-flex items-center gap-2 bg-[#50CF08] hover:bg-[#42B006] text-white font-bold uppercase px-6 py-3 rounded-md transition-colors focus:outline-none focus:ring-2 focus:ring-[#FEFB0E]"
          >
            <MessageCircle className="w-5 h-5" /> WhatsApp
          </a>
        </div>
      </div>
      <div className="border-t border-white/10">
        <p className="max-w-7xl mx-auto px-4 py-5 text-xs text-neutral-600">
          © {new Date().getFullYear()} Brasil Transportes — Guincho e Reboque em Belém e Região. Todos os direitos reservados.
        </p>
      </div>
    </footer>
  );
}
